import { render } from "./agency.vue?vue&type=template&id=7844c570&ts=true"
import script from "./agency.vue?vue&type=script&lang=ts"
export * from "./agency.vue?vue&type=script&lang=ts"

import "./agency.vue?vue&type=style&index=0&id=7844c570&lang=scss"

import exportComponent from "/home/quangphuc/s-tech/admin-nhaongay/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__